import React, { useState, useCallback, useContext, useMemo } from "react"
import PropTypes from "prop-types"

// Holds the Postcard Assistant panel's open/closed state. Hoisted above the
// per-page Layout so the panel — and the live ChatWidget message state with
// it — survives route changes. Layout's HeaderBar reads this via the
// Consumer; the panel itself is rendered once at App level.
const AssistantContext = React.createContext({
  isOpen: false,
  toggle: () => {},
  close: () => {}
})

export const AssistantProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const toggle = useCallback(() => setIsOpen((prev) => !prev), [])
  const close = useCallback(() => setIsOpen(false), [])
  const value = useMemo(() => ({ isOpen, toggle, close }), [isOpen, toggle, close])
  return <AssistantContext.Provider value={value}>{children}</AssistantContext.Provider>
}

AssistantProvider.propTypes = {
  children: PropTypes.node
}

export const useAssistant = () => useContext(AssistantContext)

export default AssistantContext
